import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import IconButton from "@mui/material/IconButton";
import BookmarkBorderedIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkBorderlessIcon from "@mui/icons-material/Bookmark";

const Button = styled(IconButton)(({ theme }) => {
  return {
    "&.MuiIconButton-root": {
      BackgroundColor: "transparent",
      "&:hover": {
        BackgroundColor: "transparent"
      }
    },
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

const IconWrapper = styled("div")`
  display: inline-block;
  cursor: pointer;
  position: absolute;
  top: -40px;
  pointer-events: auto;
  right: ${props => (props.isRightPage ? "0" : "auto")};
  left: ${props => (props.isLeftPage ? "0" : "auto")};
`;

const BookmarkBorderedIconRed = styled(BookmarkBorderedIcon)`
  color: #ff0000 !important;
  font-size: 5rem !important;

  &:hover {
    color: #cc0000 !important;
  }
`;

const BookmarkBorderlessIconRed = styled(BookmarkBorderlessIcon)`
  color: #ff0000 !important;
  font-size: 5rem !important;

  &:hover {
    color: #cc0000 !important;
  }
`;

function BookmarkButton({ page, isBookmarked, delBookmark, addBookmark, isLeftPage, isRightPage }) {
  function onClick() {
    if (isBookmarked) {
      delBookmark(page);
      return;
    }
    addBookmark({ page });
  }

  return (
    <IconWrapper isLeftPage={isLeftPage} isRightPage={isRightPage}>
      <Button
        disableRipple
        className="bookmark-button panzoomAllowTouch"
        onClick={onClick}
        size="large"
        aria-label={isBookmarked ? "Lesezeichen entfernen" : "Lesezeichen setzen"}
      >
        {isBookmarked ? <BookmarkBorderlessIconRed /> : <BookmarkBorderedIconRed />}
      </Button>
    </IconWrapper>
  );
}

BookmarkButton.propTypes = {
  page: PropTypes.number.isRequired,
  isBookmarked: PropTypes.bool.isRequired,
  addBookmark: PropTypes.func.isRequired,
  delBookmark: PropTypes.func.isRequired,
  isLeftPage: PropTypes.bool.isRequired,
  isRightPage: PropTypes.bool.isRequired
};

export default BookmarkButton;
